// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3L-Yf","ranges":"BmiRanges_ranges__2dQio"};